export default __webpack_public_path__ + "static/media/rightGreyArrow.c14fa511.svg";